import { Dispatch, SetStateAction, useState } from 'react';

import Input from '@/components/basicComponents/input';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import { IListDataWithId } from '@/components/dealPipeline-page/modify/types';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface CreateTagProps {
  isOpen: boolean;
  setTags: Dispatch<SetStateAction<IListDataWithId>>;
  onClose: () => void;
}

const CreateTag = ({ isOpen, setTags, onClose }: CreateTagProps) => {
  const [value, setValue] = useState('');

  const saveValue = () => {
    setTags((prevTags) => {
      const isValueExistInList = prevTags.list.some((tag) => tag.value === value);
      const isValueExistInAllList = prevTags.allList.some((tag) => tag.value === value);
      return {
        ...prevTags,
        ...(!isValueExistInList && { list: [...prevTags.list, createSimpleSelectOption(value)] }),
        ...(!isValueExistInAllList && { allList: [...prevTags.allList, createSimpleSelectOption(value)] })
      };
    });

    setTags((prevTags) => {
      if (!prevTags.list.length) {
        return {
          ...prevTags,
          selected: [...new Set([...prevTags.selected, value])]
        };
      }

      let duplicateTag: string | null = null;

      const updatedTags = prevTags.selected.map((tag) => {
        if (tag === '') {
          return value;
        }
        if (tag === value) {
          duplicateTag = value;
          return value;
        }
        return tag;
      });

      return { ...prevTags, selected: updatedTags, duplicate: duplicateTag };
    });

    setTimeout(() => {
      setTags((prevTags) => {
        return {
          ...prevTags,
          duplicate: null,
          selected: [...new Set(prevTags.selected)]
        };
      });
    }, 1000);

    return onClose();
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      confirmButton={{
        name: 'Save',
        onClick: saveValue,
        disabled: !value.length
      }}
      showRequiredFields
    >
      <ModalContainer>
        <ModalTitel>Create New Tag</ModalTitel>
        <ModalDescription>Use tags to call out common attributes on different investments.</ModalDescription>
      </ModalContainer>
      <ManagerInputWrapper>
        <Input
          label="Tag"
          placeholder="Provide a tag"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          type="text"
          size="lg"
          isRequiredField
          autoFocus
        />
      </ManagerInputWrapper>
    </ModalWrappedContent>
  );
};

export default CreateTag;

const ModalContainer = styled.div`
  font-weight: 400;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ModalTitel = styled.div`
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 19px;
  line-height: 27px;
  text-align: center;
  color: ${themeVar('font.base')};
`;

const ManagerInputWrapper = styled.div`
  padding-top: 35px;
`;
